import { useEffect, useState } from "react";
import { team as fallback } from "../data/team.js";
import { fetchTeam } from "../lib/cms.js";

export default function Team() {
  const [team, setTeam] = useState(null);
  const [source, setSource] = useState("loading");

  useEffect(() => {
    fetchTeam().then((data) => {
      if (data && data.length) {
        setTeam(data);
        setSource("cms");
      } else {
        setTeam(
          fallback.map((p, i) => ({
            id: i,
            name: p.name,
            role: p.role,
            bio: "",
            photo: "",
            link: p.link
          }))
        );
        setSource("fallback");
      }
    });
  }, []);

  return (
    <>
      <section className="page-header">
        <div className="wrap">
          <div className="eyebrow">The team</div>
          <h1>Senior partners and operators.</h1>
          <p className="sub">
            Direct points of contact across origination, investor relations,
            finance and operations. Reach any team member via <a href="mailto:info@daksfirst.com" style={{ color: "var(--gold)", textDecoration: "underline" }}>info@daksfirst.com</a>.
          </p>
        </div>
      </section>

      <section>
        <div className="wrap">
          {team === null && (
            <p className="muted" style={{ padding: "32px 0" }}>Loading team…</p>
          )}

          {team && team.length > 0 && (
            <div className="people-grid">
              {team.map((p) => (
                <article className="person-card" key={p.id}>
                  {p.photo ? (
                    <div className="person-photo">
                      <img src={p.photo} alt={p.name} loading="lazy" />
                    </div>
                  ) : (
                    <div className="person-photo person-photo-empty" aria-hidden="true">
                      <span>{(p.name || "·").slice(0, 1)}</span>
                    </div>
                  )}

                  <div className="person-body">
                    <div className="role">{p.role}</div>
                    <h3 className="name">{p.name}</h3>
                    {p.bio && <p className="bio">{p.bio}</p>}
                    {p.link && (
                      <a className="li" href={p.link} target="_blank" rel="noopener noreferrer">
                        LinkedIn →
                      </a>
                    )}
                  </div>
                </article>
              ))}
            </div>
          )}

          {source === "fallback" && team && team.length > 0 && (
            <p className="indicative spacer-l">
              Showing a static team list — full photos and bios are served from the Daksfirst CMS once CORS is configured for this domain.
            </p>
          )}
        </div>
      </section>
    </>
  );
}
